import React, {Fragment} from "react";
import { withRouter } from "react-router-dom";
import useWindowSize from "./useWindowSize";
import { useInView } from 'react-intersection-observer';

import SocialButtons from "./SocialButtons";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { faChevronUp } from '@fortawesome/free-solid-svg-icons'

const Footer = (props) => {
    function scrollToTop() {
        window.scrollTo({top: 0, behavior: 'smooth'});
    }

    const { pathname } = props.location;
    const showSocialButtons = pathname !== "/";

    const {width} = useWindowSize();
    const { ref, inView } = useInView({
        triggerOnce: true,
        rootMargin: '200px 0px',
    });

    return (
        <div ref={ref}>
        {
            inView && (
                <Fragment>
                    {showSocialButtons && <SocialButtons showSeparator={false} />}
                    <section className="mapa" >
                        
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3058.0831422269493!2d-8.63123418389137!3d39.961893791098284!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd2267d630ac6f45%3A0xc4643d065f59188a!2sElias%20Gomes%20Autom%C3%B3veis!5e0!3m2!1sen!2spt!4v1576793294477!5m2!1sen!2spt"
                                    width="100%"
                                    height="100%"
                                    frameBorder="0"
                                    scrolling="no"
                                    marginHeight="0"
                                    marginWidth="0"
                                />
                            
                    </section>
                    <section className="p-3 financiamento">
                        <div className="container text-center">
                            <div className="row justify-content-center">
                                <div className="col-md-6 mx-auto">
                                    <h1 className="display-5 font-weight-bold">
                                        CONTACTOS
                                    </h1>
                                    <h3 className="footerEmail">
                                        Venda da Cruz,
                                        <br />
                                        3105-296 Pombal - Leiria
                                    </h3>
                                    <h3 className="footerEmail">
                                        {" "}
                                        Coordenadas GPS
                                        <br />
                                        Lat: 39°57'42.8"N
                                        <br />
                                        Lng: 8°37'44.3"W
                                    </h3>
                                    <h2 className="footerEmail">
                                        <FontAwesomeIcon icon={faEnvelope}  className="mr-2"/>
                                        <a href="mailto:gameiro.elias@gmail.com">
                                            gameiro.elias@gmail.com
                                        </a>
                                    </h2>
                                </div>
                                <div className="col-md-6 mx-auto">
                                    <h1 className="display-5 font-weight-bold">
                                        HORÁRIO
                                    </h1>
                                    <div className="d-flex justify-content-center pl-5 pr-5">
                                        <ul className="px-0 w-100">
                                            <li className="d-flex justify-content-between">
                                                Segunda-Feira{" "}
                                                <span>9:30-19:00</span>
                                            </li>
                                            <li className="d-flex justify-content-between">
                                                Terça-Feira <span>9:30-19:00</span>
                                            </li>
                                            <li className="d-flex justify-content-between">
                                                Quarta-Feira <span>9:30-19:00</span>
                                            </li>
                                            <li className="d-flex justify-content-between">
                                                Quinta-Feira <span>9:30-19:00</span>
                                            </li>
                                            <li className="d-flex justify-content-between">
                                                Sexta-Feira <span>9:30-19:00</span>
                                            </li>
                                            <li className="d-flex justify-content-between">
                                                Sábado <span>9:30-19:00</span>
                                            </li>
                                            <li className="d-flex justify-content-between">
                                                Domingo <span>Fechado</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="pb-4 pt-3 d-flex justify-content-center position-relative">
                        <img
                            sizes="(max-width: 1400px) 100vw, 1400px"
                            srcSet="
                                /images/logotipo_wciw5w_c_scale,w_200.png 800w,
                                /images/logotipo_wciw5w_c_scale,w_1400.png 1400w"
                            src="/images/logotipo_wciw5w_c_scale,w_200.png"
                            alt="Elias Gomes Automoveis Logo"
                            className="footerLogotipo"
                            loading="lazy"
                            width={width > 768 ? "500":"215"}
                            height={width > 768 ? "98":"42"}
                        />
                        <a
                            className="btn btn-dark btn-lg topChevron"
                            onClick={scrollToTop}
                        >
                            <FontAwesomeIcon icon={faChevronUp}  className="text-white"/>
                        </a>
                    </section>
                </Fragment>
            )
        }
        </div>
    );
}

const FooterWrapper = withRouter(props => <Footer {...props} />);
export default FooterWrapper;
